import { Button, Meta, theme } from 'aimo-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledWrapper } from 'styles/ContainerStyles';
import { useUiStore } from 'stores/uiStore';

const AccountRemovalPreventedLinkedService = () => {
  const { t } = useTranslation();

  return (
    <StyledWrapper mb={0}>
      <StyledWrapper mb={40}>
        <Meta
          center
          color={theme.colors.gray300}
          testID="account-remove-prevent-reason-linked-service">
          {t('account.remove.preventedLinkedService')}
        </Meta>
      </StyledWrapper>
      <StyledWrapper mb={0}>
        <Button
          size="l"
          onPress={() => useUiStore.getState().setSheetModal('')}
          text={t('button.close')}
          testID="close-button"
        />
      </StyledWrapper>
    </StyledWrapper>
  );
};

export default AccountRemovalPreventedLinkedService;
